import { render, staticRenderFns } from "./addAreaDialog.vue?vue&type=template&id=22b04993&scoped=true"
import script from "./addAreaDialog.vue?vue&type=script&lang=js"
export * from "./addAreaDialog.vue?vue&type=script&lang=js"
import style0 from "./addAreaDialog.vue?vue&type=style&index=0&id=22b04993&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b04993",
  null
  
)

export default component.exports